"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateIssueStatusesVisibilityAction = exports.reducer = exports.issueStatusesSlice = exports.getIssueStatusesEntities = exports.getAllStatuses = exports.getActiveStatuses = exports.fetchActiveStatusesAction = exports.STATE_KEY = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _sdk = require("../../../../sdk");
const allStatuses = [_sdk.IssueStatus.Draft, _sdk.IssueStatus.Open, _sdk.IssueStatus.Pending, _sdk.IssueStatus.InProgress, _sdk.IssueStatus.Completed, _sdk.IssueStatus.InReview, _sdk.IssueStatus.NotApproved, _sdk.IssueStatus.InDispute, _sdk.IssueStatus.Closed];

// These statuses can not be set to "inactive" - so we disable editing for these in the UI
const MANDATORY_ACTIVE_STATUSES = [_sdk.IssueStatus.Draft, _sdk.IssueStatus.Open, _sdk.IssueStatus.Closed];
const initialState = {
  activeStatuses: [],
  pendingUpdates: null,
  numOfPendingUpdates: 0
};
const issueStatusesSlice = exports.issueStatusesSlice = (0, _toolkit.createSlice)({
  name: "issueStatuses",
  initialState,
  reducers: {
    fetchIssueActiveStatusStart(state) {
      state.numOfPendingUpdates++;
    },
    fetchIssueActiveStatusSuccess(state, action) {
      state.activeStatuses = action.payload;
      if (state.numOfPendingUpdates > 0) {
        state.numOfPendingUpdates--;
      }
    },
    fetchIssueActiveStatusFailure(state) {
      if (state.numOfPendingUpdates > 0) {
        state.numOfPendingUpdates--;
      }
    },
    setPendingUpdates(state, action) {
      state.pendingUpdates = buildEntitiesFromActiveStatuses(action.payload.pendingActiveStatusesData);
    },
    maybeNullifyPendingUpdates(state) {
      if (state.numOfPendingUpdates === 0) {
        state.pendingUpdates = null;
      }
    }
  }
});
const getIssueStatusesState = state => state[STATE_KEY];
const {
  fetchIssueActiveStatusStart,
  fetchIssueActiveStatusSuccess,
  setPendingUpdates,
  fetchIssueActiveStatusFailure,
  maybeNullifyPendingUpdates
} = issueStatusesSlice.actions;
const fetchActiveStatusesAction = () => async (dispatch, getState, _ref) => {
  let {
    sdk
  } = _ref;
  dispatch(fetchIssueActiveStatusStart());
  try {
    const activeStatues = await sdk.IssueStatuses.getAll();
    dispatch(fetchIssueActiveStatusSuccess(activeStatues));
    return activeStatues;
  } catch (e) {
    console.error("Could not fetch active statuses");
  }
};
exports.fetchActiveStatusesAction = fetchActiveStatusesAction;
const updateIssueStatusesVisibilityAction = _ref2 => {
  let {
    newIsActive,
    status
  } = _ref2;
  return async (dispatch, getState, _ref3) => {
    let {
      sdk
    } = _ref3;
    dispatch(fetchIssueActiveStatusStart());
    const {
      pendingUpdates,
      activeStatuses: storedActiveStatuses
    } = getIssueStatusesState(getState());
    let activeStatuses;
    if (pendingUpdates) {
      activeStatuses = pendingUpdates.filter(pendingStatusData => pendingStatusData.isActive).map(pendingStatusData => pendingStatusData.status);
    } else {
      activeStatuses = storedActiveStatuses;
    }
    let newActiveStatuses;
    if (newIsActive) {
      newActiveStatuses = [...activeStatuses, status];
    } else {
      newActiveStatuses = activeStatuses.filter(activeStatus => activeStatus !== status);
    }
    dispatch(setPendingUpdates({
      pendingActiveStatusesData: newActiveStatuses
    }));
    try {
      const newStatuses = await sdk.IssueStatuses.set(newActiveStatuses);
      dispatch(fetchIssueActiveStatusSuccess(newStatuses));
      dispatch(maybeNullifyPendingUpdates());
    } catch (e) {
      console.error("Unable to update status");
      dispatch(fetchIssueActiveStatusFailure());
      dispatch(maybeNullifyPendingUpdates());
      throw e;
    }
  };
};
exports.updateIssueStatusesVisibilityAction = updateIssueStatusesVisibilityAction;
const getActiveStatuses = exports.getActiveStatuses = (0, _toolkit.createSelector)(getIssueStatusesState, issueStatusesState => {
  return issueStatusesState.activeStatuses;
});
const buildEntitiesFromActiveStatuses = activeStatuses => {
  return allStatuses.map(supportedStatus => {
    return {
      status: supportedStatus,
      isActive: activeStatuses.includes(supportedStatus),
      shouldDisableEditing: MANDATORY_ACTIVE_STATUSES.includes(supportedStatus)
    };
  });
};
const getAllStatuses = exports.getAllStatuses = (0, _toolkit.createSelector)(getActiveStatuses, activeStatuses => {
  return buildEntitiesFromActiveStatuses(activeStatuses);
});
const getIssueStatusesEntities = exports.getIssueStatusesEntities = (0, _toolkit.createSelector)(getIssueStatusesState, getAllStatuses, (issueStatusesState, allStatuses) => {
  var _issueStatusesState$p;
  return (_issueStatusesState$p = issueStatusesState.pendingUpdates) !== null && _issueStatusesState$p !== void 0 ? _issueStatusesState$p : allStatuses;
});
const reducer = exports.reducer = issueStatusesSlice.reducer;
const STATE_KEY = exports.STATE_KEY = issueStatusesSlice.name;
//# sourceMappingURL=issueStatuses.js.map